// src/components/atoms/Checkbox.tsx
import React from 'react'
import styled from 'styled-components'
interface CheckboxProps {
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  id: string
}

const StyledCheckbox = styled.input`
width: 20px;
  height: 20px;
  cursor: pointer;
  border: 2px solid transparent;
  background: 
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(133.16deg, #FFC951 -4.52%, #CE56B0 107.63%) border-box;
  border-radius: 5px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;

  &:checked {
    width: 21px;
    background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
    border: 2px solid transparent;
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: -1px;
    left: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  }
`
const CheckboxImage = styled.img`
  width: 25px;
  height: 25px;
`

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, id }) => {
  return (
    <StyledCheckbox
      id={id}
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
  )
}

export default Checkbox
